// extracted by mini-css-extract-plugin
export default {"wrapper":"PurchaseFlatPage_wrapper__yVKVm","content_wrapper":"PurchaseFlatPage_content_wrapper__MA6gz","content":"PurchaseFlatPage_content__kXLYp"};